<template>
  <div class="mc-report-view__table">
    <div class="row">
      <!-- Search -->
      <div class="col-md-12">
        <div class="mc-table-view">
          <div
            id="tickets-table_filter"
            class="dataTables_filter text-md-end float-end"
          >
            <label
              class="d-inline-flex align-items-center mc-table-view__search"
            >
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="ms-2"
                @input="searchData"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table
              :rows="3"
              :columns="fields.length"
              :table-props="{ bordered: false, striped: true }"
            >
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table
          class="datatables"
          :items="listData"
          :fields="fields"
          bordered
          responsive="lg"
          show-empty
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :filter-included-fields="filterOn"
        >
          <template #cell(startTime)="data">
            {{
              data.item.reportVehicleTrip
                ? momentDateShortMonth(data.item.reportVehicleTrip.startTime)
                : "-"
            }}<br />
            <span class="text-muted">{{
              data.item.reportVehicleTrip
                ? momentTimeSeconds(data.item.reportVehicleTrip.startTime)
                : "-"
            }}</span>
          </template>
          <template #cell(stopTime)="data">
            {{
              data.item.reportVehicleTrip
                ? momentDateShortMonth(data.item.reportVehicleTrip.stopTime)
                : "-"
            }}<br />
            <span class="text-muted">{{
              data.item.reportVehicleTrip
                ? momentTimeSeconds(data.item.reportVehicleTrip.stopTime)
                : "-"
            }}</span>
          </template>
          <template #cell(driver)="data">
            {{
              data.item.reportVehicleTrip.vehicle
                ? data.item.reportVehicleTrip.vehicle.driver1
                  ? data.item.reportVehicleTrip.vehicle.driver1.fullname
                  : "-"
                : "-"
            }}
          </template>

          <template #cell(vehicle)="data">
            {{
              data.item.reportVehicleTrip.vehicle
                ? data.item.reportVehicleTrip.vehicle.licensePlate
                : "-"
            }}
          </template>

          <template #cell(startLocation)="data">
            <a
                class="link-primary"
                :href="`https://www.google.com/maps/search/?api=1&query=${data.item.reportVehicleTrip.startLat},${data.item.reportVehicleTrip.startLong}`"
                target="_blank"
                v-if="data.item.reportVehicleTrip && data.item.reportVehicleTrip.startLat && data.item.reportVehicleTrip.startLong && data.item.reportVehicleTrip.startAddress"
                >{{data.item.reportVehicleTrip.startAddress}}</a>
            <span v-else>-</span>
          </template>

          <template #cell(endLocation)="data">
            <a
                class="link-primary"
                :href="`https://www.google.com/maps/search/?api=1&query=${data.item.reportVehicleTrip.stopLat},${data.item.reportVehicleTrip.stopLong}`"
                target="_blank"
                v-if="data.item.reportVehicleTrip && data.item.reportVehicleTrip.stopLat && data.item.reportVehicleTrip.stopLong && data.item.reportVehicleTrip.stopAddress"
                >{{data.item.reportVehicleTrip.stopAddress}}</a>
            <span v-else>-</span>
          </template>

          <template #cell(vehicleType)="data">
            {{
              data.item.reportVehicleTrip.vehicle
                ? data.item.reportVehicleTrip.vehicle.vehicleType
                  ? data.item.reportVehicleTrip.vehicle.vehicleType.manufacturer
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.reportVehicleTrip.vehicle
                ? data.item.reportVehicleTrip.vehicle.vehicleType
                  ? data.item.reportVehicleTrip.vehicle.vehicleType.model
                  : "-"
                : "-"
            }}
            /
            {{
              data.item.reportVehicleTrip.vehicle
                ? data.item.reportVehicleTrip.vehicle.vehicleType
                  ? data.item.reportVehicleTrip.vehicle.vehicleType.type
                  : "-"
                : "-"
            }}
          </template>

          <template #cell(tripMileage)="data">
            {{ minimizeFloat(data.item.reportVehicleTrip.tripMileage) }}
          </template>

          <template #cell(totalTimeTrip)="data">
            {{ data.item.totalTimeTrip }}
          </template>

          <template #cell(totalHourStop)="data">
            {{ data.item.totalHourStop }}
          </template>

          <template #cell(fuelEficiency)="data">
            {{ minimizeFloat(data.item.fuelEficiency) }}
          </template>

          <template #cell(eficiency)="data">
            {{ minimizeFloat(data.item.eficiency) }}
          </template>

          <template #cell(averageSpeed)="data">
            {{ minimizeFloat(data.item.averageSpeed) }}
          </template>

          <template slot="bottom-row" v-if="filteredItems.length > 0">
            <b-td v-for="field in fields" :key="field.key">
              <template v-if="footerArr.includes(field.key)">
                {{ totalFooter[field.key] }}
              </template>
              <template v-else>
                <template v-if="field.key == 'startTime'"> Total </template>
                <template v-else-if="field.key == 'stopTime'">
                  {{ calculateDay(periode[0], periode[1]) }} Hari
                </template>
                <template v-else> - </template>
              </template>
            </b-td>
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="fields.length > 0">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Menampilkan
            <b-form-select
              class="form-select form-select-sm"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
            entri. 
            <p>Menampilkan <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
                - <strong>{{ Math.min( (currentPage - 1) * perPage + reportVehicleTrip.reportVehicleTrips.length, currentPage * perPage, totalRows) }}</strong> dari
                <strong>{{ totalRows }}</strong>
              </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows == null ? rows : totalRows"
              :per-page="perPage"
              @change="changePage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_REPORT_HISTORY_FLEET } from "@/services/api/report/report";
import moment from "moment";
import { Helper, debounce } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_EXCEL_REPORT_HISTORY_VEHICLE } from "@/services/api/report/excel";
import { EXPORT_PDF_REPORT_HISTORY_VEHICLE } from "@/services/api/report/pdf";

moment.locale("id");

export default {
  name: "FleetHistoryTable",
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      reportVehicleTrip: {
        reportVehicleTrips: [],
      },
      fields: [],
      isLoading: false,
      fileName: "",
      openSection: false,
      periode: [],
      filtersField: [],
      isEmpty: true,
      totalFooter: {
        tripMileage: 0,
        totalTimeTrip: 0,
        totalHourStop: 0,
        eficiency: 0,
        averageSpeed: 0,
      },
      footerArr: [
        "tripMileage",
        "totalTimeTrip",
        "totalHourStop",
        "eficiency",
        "averageSpeed",
      ],
      filteredItems: [],
      drivers:[],
    };
  },
  watch:{
      perPage: function(val){
          this.currentPage = 1
          this.perPage = val
          this.refreshData()
      },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.reportVehicleTrip.reportVehicleTrips.length;
    },
    listData() {
      return this.reportVehicleTrip.reportVehicleTrips;
    },
  },
  mounted() {
    this.totalRows = this.reportVehicleTrip.reportVehicleTrips.length;
  },
  methods: {
    changePage(page) {
      this.currentPage = page
      this.refreshData()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    refreshData() {
      this.isLoading = true;
      this.isEmpty = true;
      this.reportVehicleTrip.reportVehicleTrips = [];
      const periode = this.periode;
      const filter = this.filtersField;
      const driver = this.drivers;
      const search = this.filter;
      const pagination = {
        show: this.perPage,
        page: this.currentPage,
      };

      let filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      let drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      let filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        ...filters,
        ...drivers,
        pagination,
        search,
      };

      let self = this;
      let getData = this.$apollo
        .query({
          query: GET_REPORT_HISTORY_FLEET,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          let data = res.data;
          self.totalRows = data.reportVehicleTrip.reportVehicleTrips.pagination.total;
          if (data.reportVehicleTrip.reportVehicleTrips.reportVehicleTrips.length === 0) {
            self.isEmpty = true;
            self.reportVehicleTrip.reportVehicleTrips = [];
            self.isLoading = false;
            self.filteredItems = [];
            return [];
          }
          self.isEmpty = false;
          self.reportVehicleTrip.reportVehicleTrips =
            data.reportVehicleTrip.reportVehicleTrips.reportVehicleTrips;
          self.filteredItems = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTrips;

          self.isLoading = false;
          self.totalFooter.tripMileage = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTripDataTotal.totalTripMileage;
          self.totalFooter.totalTimeTrip = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTripDataTotal.totalTimeTrip;
          self.totalFooter.totalHourStop = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTripDataTotal.totalTimeTripStop;
          self.totalFooter.eficiency = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTripDataTotal.totalEfficiency;
          self.totalFooter.averageSpeed = data.reportVehicleTrip.reportVehicleTrips.reportVehicleTripDataTotal.averageSpeed;
          return data;
        });

      return getData;
    },

    openTable(periode, filter, driver, fields) {
      this.periode = periode;
      this.filtersField = filter;
      this.drivers = driver;
      this.fields = fields;
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData();
          this.openSection = false;
        }, 800);
      });
    },
    searchData: debounce(async function () {
      this.currentPage = 1;
      await this.refreshData()
    }, 1000),

    downloadToExcel(periode, filter, driver, fields) {
      let filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      var drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...drivers,
        search: this.filter,
      };

      var downloadProgress = {
        name:
          "Riwayat Kendaraan " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "excel",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_EXCEL_REPORT_HISTORY_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.excelReportVehicleTrip.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },

    downloadToPdf(periode, filter, driver, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }

      var drivers = {};
      if (driver !== undefined && driver.length > 0) {
        drivers = {
          driverId: driver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0]).toISOString(),
        endDate: moment(periode[1]).toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...drivers,
        search: this.filter,
      };

      var downloadProgress = {
        name:
          "Riwayat Kendaraan " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      var self = this;
      this.$apollo
        .query({
          query: EXPORT_PDF_REPORT_HISTORY_VEHICLE,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          var isSuccessful = res.data.pdfReportVehicleTrip.isSuccessful;
          if (isSuccessful) {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 100,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          } else {
            clearInterval(intervalDownload);
            self.$parent.$parent.$parent.refreshDownloadHistory();
            setTimeout(() => {
              self.$store.commit("report/updateProgress", {
                progress: downloadProgress,
                percentage: 90,
              });
              self.$store.commit("report/deleteProgress", downloadProgress);
            }, 500);
          }
        });
    },
  },
};
</script>
